<template>
  <div v-if="loading" class="p-12 text-center">
    <Loader />
  </div>
  <div v-else>
    <div v-for="insight in insights" :key="insight.id" class="divide-y divide-gray-200">
      <div class="px-4 py-3 sm:px-6 sm:py-4">
        <h3 class="text-lg font-medium">
          {{ insight.title }}
        </h3>
        <p class="text-gray-600 text-sm">
          {{ insight.description }}
        </p>
      </div>
      <div class="px-4 py-3 sm:px-6 sm:py-4">
        <table class="table-fixed w-full">
          <thead class="text-sm">
            <tr>
              <th v-if="insight.values.length > 1" class="border px-4 py-2 w-32">Date</th>
              <th class="border px-4 py-2">Category</th>
              <th class="border px-4 py-2 w-32 text-right">Total</th>
            </tr>
          </thead>
          <template v-if="insight.values">
            <TableTbody
              v-for="(value, valueIdx) in insight.values"
              :key="valueIdx"
              :metric="metric.name"
              :display-date="insight.values.length > 1"
              :insights="value"
            />
          </template>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { accountFacebookPageInstagramInsightsClient } from '@/api/clients';
import { LIFETIME } from '@/utils/instagram-insights-query-params';
import TableTbody from './metric-table-view-tbody.vue';

export default {
  components: {
    TableTbody,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    facebookPageId: {
      type: String,
      required: true,
    },
    metric: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      insights: null,
      rejectReason: null,
    };
  },
  created() {
    this.loadInsights();
  },
  methods: {
    async loadInsights() {
      try {
        this.loading = true;

        const response = await accountFacebookPageInstagramInsightsClient.read(
          this.accountId,
          this.facebookPageId,
          {
            metric: this.metric.name,
            period: LIFETIME,
          }
        );

        this.insights = response.data;
      } catch (error) {
        this.rejectReason = error.message;
      } finally {
        this.loading = false;
      }
    },
    getTotalRows(obj) {
      return Object.keys(obj).length;
    },
    getHumanReadableDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
  },
};
</script>
